
import facebook from '../assets/images/brands/facebook.png';
import google from '../assets/images/brands/google.png';
import apple from '../assets/images/brands/apple.png';

import logo_white from '../assets/logos/logo_white.png';
import app_icon_default from '../assets/logos/app_icon_default.png';
import app_icon from '../assets/logos/app_icon.png';
import logo_1 from '../assets/logos/logo_1.png';
import logo_2 from '../assets/logos/logo_2.png';

import default_avatar from "../assets/images/defaults/default_avatar.png";
import default_image from "../assets/images/defaults/default_image.png";
import default_banner from "../assets/images/defaults/default_image.png";
import sample_avatar from "../assets/images/defaults/sample_avatar.png";

import home from '../assets/icons/figshelf/home.svg';
import ShelfUpdateIcon from '../assets/icons/ShelfUpdateIcon';
import FigureNewsIcon from '../assets/icons/FigureNewsIcon';


// STICKERS
import collected from '../assets/images/stickers/collected.png';
import figure_news from '../assets/images/stickers/figure-news.png';
import figure_review from '../assets/images/stickers/figure-review.png';
import for_sale from '../assets/images/stickers/for-sale.png';
import looking_for from '../assets/images/stickers/looking-for.png';
import mail_call from '../assets/images/stickers/mail-call.png';
import need_help from '../assets/images/stickers/need-help.png';
import shelf_update from '../assets/images/stickers/shelf-update.png';
import trade_only from '../assets/images/stickers/trade-only.png';
import trade_or_sell from '../assets/images/stickers/trade-or-sell.png';
import unboxing from '../assets/images/stickers/unboxing.png';

import collected_mini from '../assets/images/stickers/collected-mini.png';
import figure_news_mini from '../assets/images/stickers/figure-news-mini.png';
import figure_review_mini from '../assets/images/stickers/figure-review-mini.png';
import for_sale_mini from '../assets/images/stickers/for-sale-mini.png';
import looking_for_mini from '../assets/images/stickers/looking-for-mini.png';
import mail_call_mini from '../assets/images/stickers/mail-call-mini.png';
import need_help_mini from '../assets/images/stickers/need-help-mini.png';
import shelf_update_mini from '../assets/images/stickers/shelf-update-mini.png';
import trade_only_mini from '../assets/images/stickers/trade-only-mini.png';
import trade_or_sell_mini from '../assets/images/stickers/trade-or-sell-mini.png';
import unboxing_mini from '../assets/images/stickers/unboxing-mini.png';

import image_Calendar from '../assets/images/images/Calendar.png';
import image_Figure from '../assets/images/images/Figure.png';
import image_Media from '../assets/images/images/Media.png';



export const other_images = {
    image_Calendar,
    image_Figure,
    image_Media
}

export const icons = {
    home,
    ShelfUpdateIcon,
    FigureNewsIcon
}

export const stickers = {
    collected,
    figure_news,
    figure_review,
    for_sale,
    looking_for,
    mail_call,
    need_help,
    shelf_update,
    trade_only,
    trade_or_sell,
    unboxing,
}

export const stickers_mini = {
    collected_mini,
    figure_news_mini,
    figure_review_mini,
    for_sale_mini,
    looking_for_mini,
    mail_call_mini,
    need_help_mini,
    shelf_update_mini,
    trade_only_mini,
    trade_or_sell_mini,
    unboxing_mini
}

export const images = {
    default_avatar: sample_avatar,
    default_banner,
    default_image,
    sample_avatar
}

export const brands = {
    facebook,
    google,
    apple
};

export const logos = {
    logo_white,
    app_icon_default,
    app_icon,
    logo_1,
    logo_2
};
